export const projectsData = [
  {
    title: "Recipy App",
    img: "https://raw.githubusercontent.com/achichikalova/recipy/main/public/images/home_page.png",
    description: "React Application using Spoonacular API. Responsive design.",
    stacks: ["React.js", "Axios", "SASS"],
    source: "https://github.com/achichikalova/recipy",
    demo: "https://recipy-app-react.web.app/",
  },
  {
    title: "Stacks",
    img: "https://github.com/achichikalova/Stacks/blob/main/frontend/public/static/images/readme/main_page.png?raw=true",
    description:
      "A budgeting app designed to help one track their expenses and user patterns/trends to help maintain finances.",
    stacks: ["React.js", "Node.js/Express", "PSQL", "Material-UI", "SASS"],
    source: "https://github.com/achichikalova/Stacks",
    demo: "",
  },
  {
    title: "Netflix Clone",
    img: "https://raw.githubusercontent.com/achichikalova/netflix_clone/main/public/images/login.jpg",
    description:
      "Front End version of Netflix with Firebase Authentication and MovieDB API. Responsive design.",
    stacks: ["React.js", "JavaScript", "CSS", "MovieDB API"],
    source: "https://github.com/achichikalova/netflix_clone",
    demo: "https://netflix-clone-4e8a2.web.app/",
  },
];
